const TaxSummaryGroup = require('@/lib/Tax/TaxSummaryGroup');

/**
 * Accepts an array of TaxSummaryGroups and returns some new groups that
 * are only combined by the supplied key, nothing else.
 *
 * @param {TaxSummaryGroup[]} groups
 * @param {string} key
 *
 * @return {TaxSummaryGroup[]}
 */
const groupTaxSummaryGroupsByKey = (groups, key) => {
    /**
     * @type {Object.<number, TaxSummaryGroup>}
     */
    const groupsByKey = {};

    groups.forEach((group) => {
        if (!groupsByKey.hasOwnProperty(group[key])) {
            groupsByKey[group[key]] = new TaxSummaryGroup({
                [key]: group[key],
            });
        }

        groupsByKey[group[key]].addGroup(group);
    });

    return Object.values(groupsByKey);
};

/**
 * @param {TaxSummaryGroup[]} groups
 */
const sortTaxSummaryGroupsByRate = (groups) => {
    groups.sort((a, b) => (a.taxRate > b.taxRate ? 1 : -1));
};

/**
 * Extract the first tax summary group from the given array of TaxSummaryGroups
 * where the key matches the given value.
 *
 * @param {TaxSummaryGroup[]} groups
 * @param {string} key
 * @param {{}} value
 *
 * @return {TaxSummaryGroup|null}
 */
const extractTaxSummaryGroupByKey = (groups, key, value) => {
    return groups.find((group) => group[key] === value) || null;
};

/**
 * @param {TaxSummaryGroup[]} groups
 *
 * @return {TaxSummaryGroup}
 */
const sumTaxSummaryGroups = (groups) => {
    const result = new TaxSummaryGroup();

    groups.forEach((group) => {
        result.addGroup(group);
    });

    return result;
};

module.exports = {
    extractTaxSummaryGroupByKey,
    groupTaxSummaryGroupsByKey,
    sortTaxSummaryGroupsByRate,
    sumTaxSummaryGroups,
};
